const MERMAID_FENCE_PATTERN = /^```(?:mermaid)?\s*\n?([\s\S]*?)\n?```$/i;

export const normalizeMermaidDiagram = (diagram: string): string => {
  const trimmed = diagram.trim();
  const fencedMatch = trimmed.match(MERMAID_FENCE_PATTERN);

  if (fencedMatch?.[1]) {
    return fencedMatch[1].trim();
  }

  return trimmed;
};
